import { useQuery } from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import { getLocalStorage } from '@/Utils/CommonUtils';
import type { RenewalResponse } from '@/Hooks/RenewalApi/useGetRenewalForUser';

/**
 * Response shape matches get_renewal_for_user but without current_subscription.
 * Compatible with RenewalResponse for use in RenewalPaymentScreen.
 */
export type PricingForNewUserResponse = Omit<RenewalResponse, 'current_subscription'> & {
  current_subscription?: never;
  country?: string;
  currency?: string;
};

export default function useGetPricingForNewUser(level: string | null, enabled: boolean = true) {
  return useQuery<PricingForNewUserResponse>(
    ['pricing-for-new-user', level],
    async () => {
      const token = await getLocalStorage('access_token');
      if (!token) {
        throw new Error('Authentication token not found');
      }
      const response = await ChessRestClient.get<PricingForNewUserResponse>(
        `subscription/v1/get-pricing-for-new-user/`,
        {
          params: { level: level ?? '' },
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );
      return response.data;
    },
    {
      enabled: Boolean(enabled && level),
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  );
}
